import { createReducer, on } from '@ngrx/store';
import {
  clearUserData,
  setUserData,
  setUserDataFailure,
  setUserDataSuccess,
} from '../actions/user-data.actions';
import { BoelsGenericState, BoelsUser, UserEnum } from '@boels/models';

export interface BoelsUserDataState extends BoelsGenericState {
  userData?: BoelsUser;
}

export const initialState: BoelsUserDataState = {
  error: false,
  loading: true,
  success: false,
};

export const userDataReducer = createReducer(
  initialState,
  on(clearUserData, () => ({
    ...initialState,
    userData: { type: UserEnum.ANONYMOUS },
    loading: false,
  })),
  on(setUserData, (state, { user }) => ({
    ...state,
    userData: user,
    loading: false,
  })),
  on(setUserDataSuccess, (state, { user }) => ({
    ...state,
    userData: {
      ...state.userData,
      type: user.type,
      debtor: user.debtor,
    },
  })),
  on(setUserDataFailure, (state, { error }) => ({
    ...state,
    userData: { type: UserEnum.ANONYMOUS },
    loading: false,
    error,
  })),
);
